import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import apiClient from '@/apiClient'
import { toast } from 'sonner'

export type MessagePack = {
  code: string
  name: string
  messages: number
  priceCfa: number
}

export type PackRequestResult = {
  ok: true
  purchase: { id: string; amountCfa: number; status: string }
  pack: MessagePack
  instructions: string
}

export const useMessagePacksQuery = (enabled = true) =>
  useQuery({
    queryKey: ['message-packs'],
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<MessagePack[]>('/message-packs')
      return data
    },
  })

export const useRequestPackMutation = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (code: string) => {
      const { data } = await apiClient.post<PackRequestResult>(
        `/message-packs/${code}/request`
      )
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['owner-billing-overview'] })
    },
    onError: (e: any) => {
      toast.error('Demande impossible', {
        description: e?.response?.data?.message ?? 'Erreur inconnue',
      })
    },
  })
}
